export const siteConfig = {
  title: 'CERN Knowledge Transfer 2023 Highlights',
  description:
    "Explore how CERN's research drives innovation in healthcare, renewable energy, aerospace, and quantum fields, benefiting society through partnerships and groundbreaking initiatives.",
  copyright: 'CERN Audiovisual Media',
  /** Without additional '/' on the end, e.g. https://theodorusclarence.com */
  url: process.env.NEXT_PUBLIC_CANNONICAL_URL ?? 'https://report2023.kt.cern',
  organization: 'CERN',
};
